import { render, staticRenderFns } from "./ToiletBoxCreateScreen.vue?vue&type=template&id=51b47df4&scoped=true&lang=pug"
import script from "./ToiletBoxCreateScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxCreateScreen.vue?vue&type=style&index=0&id=51b47df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b47df4",
  null
  
)

export default component.exports